import { ThunkAction } from 'redux-thunk'
import { Action, Dispatch } from 'redux'
import { ApplicationState } from 'store'
import { Config, READ_CONFIG } from './types'
import { ConfigActionTypes } from './types'
import { APIRequest } from '@lynx/client-core/src/api'

const readConfigInternal = (config: Config): ConfigActionTypes => {
	return {
		type: READ_CONFIG,
		payload: config
	}
}

export const readConfig =
	(): ThunkAction<Promise<boolean>, ApplicationState, null, Action<string>> =>
	async (dispatch: Dispatch): Promise<boolean> => {
		try {
			const configJSON = await fetch('/config.json')
			const config: Config = await configJSON.json()

			if (config) {
				APIRequest.setConfig(config)
				dispatch(readConfigInternal(config))

				return true
			} else {
				console.error('Config not found')
				return false
			}
		} catch (e) {
			console.error(e)
			return false
		}
	}
